// extracted by mini-css-extract-plugin
module.exports = {"loader":"Loader_loader__4rpL7","relative":"Loader_relative__4owW3","holder":"Loader_holder__4nEUo","box":"Loader_box__1uENV","ani-box":"Loader_ani-box__2zOcH"};